import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dynamic-textarea',
  templateUrl: './dynamic-textarea.component.html',
  styleUrls: ['./dynamic-textarea.component.css']
})
export class DynamicTextareaComponent implements OnInit {

  @Input() data;
  @Output() public dataOut = new EventEmitter();
  // GUI Values
  inputHint;
  placeholder = '';
  editMode = false;
  
    
  constructor() { }

  ngOnInit(): void {
  }

  getShortValue(buffer){
    if(buffer){
      return buffer.slice(0,15)+ '...';
    }else{
      return '';
    }
  }

  switchEditingMode(){
    this.editMode = !this.editMode;
  }

}
